import { TFunction } from "i18next";
import { RegistrationFormSectionResourceTypeCompanionSection } from "../../shared/types";

export const validateCompanionSection = (
	companionSection: RegistrationFormSectionResourceTypeCompanionSection,
	companionCount: number,
	t: TFunction,
): Record<number, string> | null => {
	const companionSectionErrors: Record<number, string> | null = {};

	const minCount = companionSection.companionSettings.minCompanionCount;
	if (minCount && companionCount < minCount) {
		companionSectionErrors[companionSection.id] = t(`You need min. {{count}} {{companionType}}`, {
			count: minCount,
			companionType:
				minCount === 1
					? companionSection.companionSettings.companionType.singularLabel
					: companionSection.companionSettings.companionType.pluralLabel,
		});
	}
	if (Object.keys(companionSectionErrors).length > 0) {
		return companionSectionErrors;
	} else {
		return null;
	}
};
